import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import dayjs from 'dayjs';

function OnSiteProtocolModal({ open, onClose, booking }) {
  const protocolTypes = {
    arrival: 'Ankunft',
    onSitePayment: 'Vor-Ort-Zahlung',
    briefing: 'Einweisung',
    departure: 'Abreise',
    lasertagGame: 'Lasertag gespielt',
    lasertagGameAborted: 'Lasertag verpasst',
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Aktivitätsverlauf</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Zeitpunkt</TableCell>
                <TableCell>Typ</TableCell>
                <TableCell>Durchgeführt von</TableCell>
                <TableCell>Kommentar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {booking.onSiteProtocol?.map(protocol => (
                <TableRow key={protocol._id}>
                  <TableCell>{dayjs(protocol.timestamp).format('DD.MM.YYYY HH:mm')}</TableCell>
                  <TableCell>{protocolTypes[protocol.type] || protocol.type}</TableCell>
                  <TableCell>
                    {protocol.createdByUsername || protocol.createdByString || 'Unbekannt'}
                  </TableCell>
                  <TableCell>{protocol.comment}</TableCell>
                </TableRow>
              ))}
              {(!booking.onSiteProtocol || booking.onSiteProtocol.length === 0) && (
                <TableRow>
                  <TableCell colSpan={4} align='center'>
                    Keine Protokolle vorhanden
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}

export default OnSiteProtocolModal;
